<template>
  <div class="resetPwd">
    <!-- 登录注册 -->
    <el-dialog
      title="忘记密码"
      custom-class="login-form"
      :visible.sync="resetPwdVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
    >
      <div style="margin-bottom:1rem">
        <el-steps :active="stepsActive" simple finish-status="success">
          <el-step title="验证账号"></el-step>
          <!-- <el-step title="验证信息" icon="el-icon-upload"></el-step> -->
          <el-step title="重置密码"></el-step>
        </el-steps>
      </div>
      <el-container style="justify-content: center;">
        <el-form
          :model="user"
          status-icon
          :rules="rules1"
          v-show="stepsActive==0"
          ref="form1"
          style="min-height:250px"
        >
          <el-form-item prop="email">
            <el-input type="text" v-model="user.email" placeholder="请输入手机号 / 邮箱"></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-row>
              <!-- <el-col :span="16">
                <el-input
                  v-model="user.code"
                  auto-complete="off"
                  placeholder="请输入图片验证码"
                  style="width: 100%"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <div class="login-code" style="height: 50px;">
                  <img
                    :src="codeUrl"
                    @click="getCode"
                    class="login-code-img"
                    style="width:100%;height:50px;border-r"
                  />
                </div>
              </el-col> -->
              <slide-verify
                v-if="stepsActive==0"
                :l="42"
                :r="10"
                :w="350"
                :h="150"
                :imgs="images"
                @success="onSuccess"
                @fail="onFail"
                @refresh="onRefresh"
                :slider-text="text"
              ></slide-verify>
            </el-row>
          </el-form-item>
          <el-form-item prop="activationOrder">
            <el-row>
              <el-col :span="16">
                      <el-input
                          v-model="user.activationOrder"
                          auto-complete="autoComplete"
                          placeholder="验证码"
                          style="width:100%;"
                      >
                      </el-input>
                  </el-col>
                  <el-col :span="8">
                      <div class="login-code">
                          <el-button :disabled="isDisabled" @click="loginCaptcha" style="padding: 0 !important;">
                              <span>{{buttonName}}</span>
                          </el-button>
                      </div>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button type="success" style="background:#0c70fc;width:100%;" @click="next()">下一步</el-button>
          </el-form-item>
        </el-form>

        <el-form
          :model="user"
          status-icon
          :rules="rules2"
          v-show="stepsActive==1"
          ref="form2"
          style="min-height:250px"
        >
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="user.password"
              placeholder="请输入密码"
              auto-complete="new-password"
            ></el-input>
          </el-form-item>
          <el-form-item prop="checkPass">
            <el-input type="password" v-model="user.checkPass" placeholder="确认密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-form-item prop="code">
              <el-row>
                <!-- <el-col :span="16">
                    <el-input
                      v-model="user.code"
                      auto-complete="off"
                      placeholder="请输入图片验证码"
                      style="width: 100%"
                    >
                    </el-input>
                  </el-col>
                  <el-col :span="8">
                    <div class="login-code " style="height: 50px;">
                      <img :src="codeUrl" @click="getCode" class="login-code-img" style="width:100%;height:50px;border-r"/>
                    </div>
                </el-col>-->
                <slide-verify
                  v-if="stepsActive==1"
                  :l="42"
                  :r="10"
                  :w="350"
                  :h="150"
                  :imgs="images"
                  @success="onSuccess"
                  @fail="onFail"
                  @refresh="onRefresh"
                  :slider-text="text"
                ></slide-verify>
              </el-row>
            </el-form-item>
            <el-button
              type="success"
              style="background:#0c70fc;width:100%;margin-top:22px;"
              @click="resetPwd()"
            >重置密码</el-button>
          </el-form-item>
        </el-form>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
import {encrypt} from '../utils/encryption'
export default {
  props: ['resetPwdVisible'],
  data () {
    var account = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号/邮箱不能为空'))
      }
      var api = this.systemURL + '/actuator/before/verifyAccount'
      var params = { email: this.user.email }
      this.axios.post(api, params).then(res => {
        if (res.data.code === 500) {
          return callback(new Error(res.data.msg))
        } else {
          callback()
        }
      })
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.user.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      verification: null,
      sessionKey: 'forgetVerificationCode',
      sessionValue: null,
      user: {
        email: null,
        phonenumber: null,
        password: null,
        activationOrder: null,
        code: null,
        uuid: null,
        verification: null,
        sessionKey: null
      },
      text: '向右拖动滑块填充拼图', // 滑块底部文字
      codeStatus: false,
      isDisabled: false,
      codeUrl: null,
      buttonName: '发送验证码',
      stepsActive: 0,
      time: 60,
      images: [],
      rules1: {
        email: [{ validator: account, trigger: 'blur' }],
        activationOrder: [
          { required: true, trigger: 'blur', message: '验证码不能为空' }
        ]/* ,
        code: [
          { required: true, trigger: "blur", message: "图片验证码不能为空" }
        ] */
      },
      rules2: {
        password: [
          { required: true, trigger: 'blur', message: '密码不能为空' }, {
            pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/,
            message: '密码长度为8-30位，且包含数字、符号、字母'
          }
        ],
        checkPass: [{ validator: validatePass, trigger: 'blur' }, {
          pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/,
          message: '密码长度为8-30位，且包含数字、符号、字母'
        }]
        /* code: [
          { required: true, trigger: "blur", message: "图片验证码不能为空" }
        ] */
      }
    }
  },
  watch: {
    stepsActive: {
      handler (newVal) {
        if (newVal >= 0) {
          this.getImages()
        }
      },
      immediate: true
    }
  },
  created () {
    this.setSessionValues(this.sessionKey)
    this.getSessionKey()
    this.setVerification()
    // this.getImages()
    /* this.getCode(); */
  },
  methods: {
    getImages () {
      var api = this.siteURL + '/actuator/storage/list?businessId=-1'
      this.axios.get(api, { businessId: '-1' }).then(res => {
        if (res.data.code === 500) {
          this.$message.error(res.data.msg)
          return
        }
        this.images = ((res.data && res.data.rows) || []).map(item => {
          return item.path
        })
      })
    },
    /* 注册登录 */
    /* getCode() {
      var api = this.systemURL + "/actuator/before/createCapcha";
      var params = {};
      this.axios.post(api, params).then(res => {
        this.codeUrl = "data:image/gif;base64," + res.data.img;
        this.user.uuid = res.data.uuid;
      });
    }, */
    setSessionValues (obj) {
      console.log(obj)
      window.sessionStorage.setItem(obj, this.getRandomCode())
    },
    // 生成随机识别码
    getRandomCode (length) {
      length = length || 32
      var text = ''
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
      }
      console.log(text)
      return text
    },
    getSessionKey () {
      this.sessionValue = window.sessionStorage.getItem(this.sessionKey)
    },
    setVerification () {
      var api = this.systemURL + '/actuator/before/insertVerification?sessionKey=' + this.sessionValue
      this.axios.get(api, null).then(res => {
        this.verification = res.data
      })
    },
    delRedisVerification () {
      window.sessionStorage.removeItem(this.sessionKey)
      var api = this.systemURL + '/actuator/before/delRedisVerification?sessionKey=' + this.sessionValue
      this.axios.get(api, null).then(res => {
        if (res.data !== true) {
          alert('删除失败')
        }
      })
    },
    checkVerification () {
      var api = this.systemURL + '/actuator/before/checkVerification?verification=' + this.verification + '&sessionKey=' + this.sessionValue
      this.axios.get(api, null).then(res => {
        if (res.data === true) {
          this.codeStatus = true
        } else {
          this.codeStatus = false
        }
      })
    },
    loginCaptcha () {
      // 发送手机验证码
      /* var code = this.user.code; */
      let email = this.user.email
      if (!email) {
        this.$message.warning('请填写手机号或邮箱')
        return
      } else if (!this.codeStatus) {
        this.$message.warning('图片验证未成功，请验证')
        return
      }/* else if (!code) {
        this.$message.warning("请填写图片验证码");
        return;
      } */

      var api = this.systemURL + '/actuator/before/getPhoneOrEmailCaptcha'
      var params = {
        account: email,
        siteId: this.siteId
      }
      this.isDisabled = true
      /* this.getCode(); */
      this.axios.post(api, params).then(res => {
        if (res.data.code === 500) {
          this.$message.error(res.data.msg)
          this.isDisabled = false
          return
        }
        if (res.data.type === 'email') {
          this.user.phonenumber = null
          this.user.email = res.data.account
          this.user.uuid = res.data.uuid
        } else if (res.data.type === 'phonenumber') {
          // this.user.email = null
          this.user.phonenumber = res.data.account
          this.user.uuid = res.data.uuid
        }
        this.$message.success(res.data.msg)
        let interval = window.setInterval(() => {
          this.buttonName = '(' + this.time + '秒)后重发'
          --this.time
          if (this.time < 0) {
            this.buttonName = '重新发送'
            this.time = 60
            this.isDisabled = false
            window.clearInterval(interval)
          }
        }, 1000)
      })
    },
    next () {
      if (!this.codeStatus) {
        this.$message.warning('图片验证未成功，请验证')
        return
      }
      this.$refs['form1'].validate(valid => {
        if (valid) {
          // 验证邮箱或短信验证码
          var api = this.systemURL + '/actuator/before/verifyPhoneOrEmailCaptcha'
          var params = this.user
          this.axios.post(api, params).then(res => {
            this.user.code = null
            /* this.getCode(); */
            if (res.data.code === 200) {
              this.stepsActive = 1
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
        this.codeStatus = false
      })
    },
    resetPwd () {
      if (!this.codeStatus) {
        this.$message.warning('图片验证未成功，请验证')
        return
      }
      this.$refs['form2'].validate(valid => {
        if (valid) {
          this.user.verification = this.verification
          this.user.sessionKey = this.sessionValue
          this.user.password = encrypt(this.user.password)
          // 验证邮箱或短信验证码
          var api = this.systemURL + '/actuator/before/resetPwdByPhoneOrEmail'
          this.axios.post(api, this.user).then(res => {
            /* this.getCode(); */
            if (res.data.code === 200) {
              this.$message.success(res.data.msg)
              this.handleClose()
            } else {
              this.$message.error(res.data.msg)
            }
            this.codeStatus = false
          })
        } else {
          console.log('error submit!!')
          this.codeStatus = false
          return false
        }
      })
    },
    handleClose () {
      this.stepsActive = 0
      this.$parent.resetPwdVisible = false
      this.isDisabled = false
      for (let key in this.user) {
        this.user[key] = null
      }
      if (!this.$store.state.user) {
        this.$store.commit('loginVisibleMutations', true)
      } else {
        this.$store.commit('loginVisibleMutations', false)
      }
      this.$store.commit('registerFormVisibleMutations', false)
      this.codeStatus = false
    },
    /* 滑动验证相关回调函数 */
    onSuccess () {
      /* 更改滚动验证状态 */
      this.codeStatus = true
      this.$message({
        message: '图片验证成功',
        type: 'success',
        duration: 2000
      })
    },
    onFail () {
      this.$message({
        message: '图片验证失败，请重新验证',
        type: 'error',
        duration: 2000
      })
      this.delRedisVerification()
      this.setSessionValues(this.sessionKey)
      this.getSessionKey()
      this.setVerification()
      this.codeStatus = false
    },
    onRefresh () {
      /* console.log("按钮刷新的回调"); */
      this.delRedisVerification()
      this.setSessionValues(this.sessionKey)
      this.getSessionKey()
      this.setVerification()
      this.codeStatus = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.grid-content {
  height: 60px;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0px;
}
.register {
  color: #1ab2ff;
  cursor: pointer;
}
.register:hover {
  color: #2c2fd6;
}
</style>

<style >
.resetPwd {
  width: 100%;
}
.resetPwd .el-tabs__nav {
  width: 100%;
  float: none;
}
.resetPwd .el-tabs__active-bar {
  background-color: #e4e7ed;
  height: 0px;
}
.resetPwd .el-radio-group {
  float: left;
  position: relative;
  top: 12px;
}
.resetPwd .el-tabs__nav-wrap::after {
  background-color: white;
}
.resetPwd .el-dialog .el-dialog__body {
  padding: 30px 60px !important;
}
@media screen and (max-width: 1200px) {
.resetPwd .el-dialog .el-dialog__body {
  padding: 10px 15px !important;
}
}
/* .el-dialog__headerbtn.el-dialog__headerbtn .el-dialog__close {
  display: none;
} */
.resetPwd .el-form-item__content .el-button--primary {
  width: 100%;
}
.resetPwd .login-code .el-button {
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0;
  color: #0c70fc;
  background-color: #eeeeee;
}
/*  */
.resetPwd .el-radio-button--small .el-radio-button__inner {
  padding: 5px 5px !important;
}
.resetPwd .el-input__inner {
  height: 50px;
  line-height: 50px;
  background-color: #fafafa;
}
.resetPwd a {
  text-decoration: none;
  color: #0c70fc;
}
.resetPwd .xieyi {
  color: #fcae48;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/resetPwd.vue